import { forwardRef, createElement } from 'react';
import cn from 'classnames';

const Group = /*#__PURE__*/forwardRef(function Group(props, ref) {
  const {
    as: Tag = 'span',
    orientation = 'horizontal',
    ...otherProps
  } = props;
  const className = cn('flex ', 'gap-2', {
    'flex-col ': orientation === 'vertical'
  }, props.className);
  return createElement(Tag, Object.assign({}, otherProps, {
    className: className,
    "data-taco": "group",
    ref: ref
  }));
});

export { Group };
//# sourceMappingURL=Group.js.map
